"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagExportState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
class TagExportState {
    constructor() {
        this.exporting = false;
    }
    setExporting(loading) {
        this.exporting = loading;
    }
}
exports.TagExportState = TagExportState;
tslib_1.__decorate([
    mobx_1.observable
], TagExportState.prototype, "exporting", void 0);
tslib_1.__decorate([
    mobx_1.action
], TagExportState.prototype, "setExporting", null);
//# sourceMappingURL=tag.export.state.js.map